import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default function Root() {
    Vue.http.options.root = 'https://api.parley.nu/adminApi';
}